import React from 'react';
import { 
  Box,
  Typography,
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper
} from '@mui/material';
import { styled } from '@mui/material/styles';

const SectionContainer = styled(Box)(({ theme }) => ({
  marginBottom: '32px',
  position: 'relative'
}));

const ComingSoonOverlay = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(255, 255, 255, 0.85)',
  backdropFilter: 'blur(4px)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '4px',
  zIndex: 10
}));

const ComingSoonText = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '24px',
  fontWeight: 700,
  color: '#34A853',
  textTransform: 'uppercase',
  letterSpacing: '2px',
  textShadow: '0 2px 4px rgba(0,0,0,0.1)',
  textAlign: 'center'
}));

const ComingSoonSubtext = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '14px',
  fontWeight: 500,
  color: '#121927',
  marginTop: '8px',
  textAlign: 'center'
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '16px',
  fontWeight: 600,
  color: '#121927',
  marginBottom: '16px'
}));

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  borderRadius: '4px',
  border: 'none',
  boxShadow: 'none',
  backgroundColor: 'transparent',
  overflowX: 'auto',
  [theme.breakpoints.down('md')]: {
    '& table': {
      minWidth: '650px'
    }
  }
}));

const StyledTableHead = styled(TableHead)(({ theme }) => ({
  backgroundColor: '#34A853'
}));

const HeaderCell = styled(TableCell)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '14px',
  fontWeight: 500,
  color: '#FFFFFF',
  padding: '16px',
  borderBottom: 'none'
}));

const DataCell = styled(TableCell)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '12px',
  fontWeight: 500,
  color: '#121927',
  padding: '16px',
  borderBottom: '1px solid #F0F0F0'
}));

const ComparisonText = styled(Typography)(({ theme, isPositive }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '12px',
  fontWeight: 500,
  color: isPositive ? '#34A853' : '#EF232A'
}));

const PhotoEngagementTable = ({ photoEngagementData }) => {
  const columns = ['Photo Type', 'Views', 'Compared to Competitor A', 'Compared to Competitor B'];

  const renderComparisonCell = (value) => {
    const isPositive = value >= 0;
    return (
      <ComparisonText isPositive={isPositive}>
        {isPositive ? '+' : ''}{value}%
      </ComparisonText>
    );
  };

  return (
    <SectionContainer>
      <SectionTitle>Google Photo Engagement Report</SectionTitle>
      
      <ComingSoonOverlay>
        <Box>
          <ComingSoonText>Coming Soon</ComingSoonText>
          <ComingSoonSubtext>Google Photo Engagement Report</ComingSoonSubtext>
        </Box>
      </ComingSoonOverlay>
      
      <StyledTableContainer component={Paper}>
        <Table>
          <StyledTableHead>
            <TableRow>
              {columns.map((column, index) => (
                <HeaderCell key={index}>{column}</HeaderCell>
              ))}
            </TableRow>
          </StyledTableHead>
          <TableBody>
            {photoEngagementData.map((item, index) => (
              <TableRow key={index}>
                <DataCell>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#121927' }}>
                    {item.photoType}
                  </Typography>
                </DataCell>
                <DataCell>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#121927' }}>
                    {item.views} views
                  </Typography>
                </DataCell>
                <DataCell>
                  {renderComparisonCell(item.competitorAComparison)}
                </DataCell>
                <DataCell>
                  {renderComparisonCell(item.competitorBComparison)}
                </DataCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </StyledTableContainer>
    </SectionContainer>
  );
};

export default PhotoEngagementTable;